<div class="dialog__close" (click)="close()" cdkFocusRegionstart>
  <span class="material-icons">close</span>
</div>

<div class="aztec-scanner-qr-dialog">

  <div class="aztec-scanner-qr-dialog__content">
    <div class="aztec-scanner-qr-dialog__img">
      <img class="aztec-scanner-qr-dialog__img--phone" [src]="phoneImageSrc" alt="">

      <div class="aztec-scanner-qr-dialog__qr-container">
        <div *ngIf="loading"
             class="aztec-scanner-qr-dialog__spinner">
          <app-container-spinner></app-container-spinner>
        </div>
        <img *ngIf="!loading"
             [src]="qrCodeImageSrc" alt="">
      </div>

    </div>

    <div class="aztec-scanner-qr-dialog__info">
      <h2>
        {{ getTranslationKey('title') | translate }}
      </h2>

      <div class="aztec-scanner-qr-dialog__arrow">
        <img [src]="arrowImageSrc"
             alt="">
      </div>

      <ol class="aztec-scanner-qr-dialog__info__list">
        <li class="aztec-scanner-qr-dialog-list-item">
          <div class="aztec-scanner-qr-dialog-list-item__title">{{ getTranslationKey('steps.step1.title') | translate }}</div>
          <div class="aztec-scanner-qr-dialog-list-item__description"
               [innerHTML]="getTranslationKey('steps.step1.description') | translate | safeHtml">
          </div>
        </li>
        <li class="aztec-scanner-qr-dialog-list-item">
          <div class="aztec-scanner-qr-dialog-list-item__title">{{ getTranslationKey('steps.step2.title') | translate }}</div>
          <div class="aztec-scanner-qr-dialog-list-item__description"
               [innerHTML]="getTranslationKey('steps.step2.description') | translate | safeHtml">
          </div>
        </li>
        <li class="aztec-scanner-qr-dialog-list-item">
          <div class="aztec-scanner-qr-dialog-list-item__title">{{ getTranslationKey('steps.step3.title') | translate }}</div>
          <div class="aztec-scanner-qr-dialog-list-item__description aztec-scanner-qr-dialog__aztec-placement">
            <img src="./assets/images/aztec-code-placement.png"
                 alt="">
            <span class="aztec-scanner-qr-dialog__aztec-placement__text"
                  [innerHTML]="getTranslationKey('steps.step3.description') | translate | safeHtml">
            </span>
          </div>
        </li>
        <li class="aztec-scanner-qr-dialog-list-item">
          <div class="aztec-scanner-qr-dialog-list-item__title">{{ getTranslationKey('steps.step4.title') | translate }}</div>
          <div class="aztec-scanner-qr-dialog-list-item__description"
               [innerHTML]="getTranslationKey('steps.step4.description') | translate | safeHtml">
          </div>
        </li>
      </ol>
    </div>
  </div>

</div>
